export enum FETCH_STATE {
  INACTIVE,
  LOADING,
  ERROR,
}

export const MESSAGE_LOADING = "CARGANDO...";
export const INVALID_NAME = "Por favor ingrese un nombre válido";
export const NOT_FOUND = "No se encontro ninguna cita";
